import activityReports from '@/http/endpoints/activityReportsEndpoints'
import aiFeed from '@/http/endpoints/aiFeed'
import prescriptionBloom from '@/http/endpoints/bloom/prescriptionEndpoints'
import config from '@/http/endpoints/configEndpoints'
import general from '@/http/endpoints/generalEndpoints'
import institutions from '@/http/endpoints/institutionsEndpoints'
import prescriptionMind from '@/http/endpoints/mind/prescriptionEndpoints'
import programGoals from '@/http/endpoints/mind/programGoalsEndpoints'
import membersMove from '@/http/endpoints/move/membersEndpoints'
import prescriptionMove from '@/http/endpoints/move/prescriptionEndpoints'
import notifications from '@/http/endpoints/notificationsEndpoints'
import patient from '@/http/endpoints/patientEndpoints'
import patientsFunnel from '@/http/endpoints/patientsFunnelEndpoints'
import patientsList from '@/http/endpoints/patientsListEndpoints'
import prescription from '@/http/endpoints/prescriptionEndpoints'
import recommendations from '@/http/endpoints/recommendationsEndpoints'
import results from '@/http/endpoints/resultsEndpoints'
import stepCountGoal from '@/http/endpoints/stepCountGoal'
import swordDesk from '@/http/endpoints/swordDesk'
import user from '@/http/endpoints/userEndpoints'
import { CONFIG } from '@/scripts/app-configs/constants'
import store from '@/store'

export function generateAuthTokens() {
  return {
    authorization: { 'Authorization': store?.getters['user/authentication/accessToken'] },
    refreshAuthorization: { 'Authorization': store?.getters['user/authentication/refreshToken'] },
  }
}

export const endpointsSpec = {
  data: {
    // TODO Is this being used ?!
    apiUrls: {
      localized: CONFIG.baseUrl,
    },
    headers: generateAuthTokens(),
  },
  modules: {
    user,
    general,
    patient,
    prescription,
    patientsList,
    institutions,
    notifications,
    recommendations,
    results,
    config,
    patientsFunnel,
    stepCountGoal,
    activityReports,
    prescriptionMove,
    prescriptionBloom,
    prescriptionMind,
    programGoals,
    membersMove,
    aiFeed,
    swordDesk,
  },
}
